// CenterwiseStudentCount.js
import React from 'react';

const CenterwiseStudentCount = () => {
    return <div>Centerwise Student Count Page</div>;
};

export default CenterwiseStudentCount;